export const partialUpdateVehicleAdapter = (data) => ({
  body: data.get('body_type'),
  miles: data.get('miles'),
  engine_name: data.get('engine_description') || undefined,
  transmission: data.get('transmission_description') || undefined,
  disclaimer: data.get('disclaimer'),
  disclaimer2: data.get('disclaimer2'),
  price: data.get('price_current')
})
